// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 182) return "js/frontend/182.js";
	if (chunkId === 160) return "js/frontend/160.js";
	if (chunkId === 695) return "js/frontend/695.js";
	if (chunkId === 927) return "js/frontend/927.js";
	// return url for filenames based on template
	return undefined;
};